module.exports = function () {
	var $bar = $('.C5-2-fixed-bottom-bar');
	var barHeight = $bar.outerHeight(true);
	var $footer = $('.A2-footer');
	var footerOffsetTop = $footer.offset().top;

	var resetOffsets = function() {
		barHeight = $bar.outerHeight(true);
		footerOffsetTop = $footer.offset().top;
	}

	var setBarPosition = function() {
		if (footerOffsetTop <= $(document).scrollTop() + window.innerHeight + barHeight) {
			$bar.removeClass('is-fixed')
		}
		else if ($(document).scrollTop() > 100) {
			$bar.addClass('is-fixed');
		}
		else {
			$bar.removeClass('is-fixed');
		}
	};

	if ($bar.length) {
		$(window).scroll(function() {
			requestAnimationFrame(setBarPosition);
		});

		$(window).resize(function () {
			resetOffsets();
			requestAnimationFrame(setBarPosition);
		});

		requestAnimationFrame(setBarPosition);
	}
};
